
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductSku extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  /**
   * Updates the sku.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateSku = (event) => {
    const newSku = event.detail.data.html.querySelector('product-sku [ref="skuContainer"]');
    const currentSku = this.querySelector('[ref="skuContainer"]');

    if (!newSku || !currentSku) return;

    if (currentSku.innerHTML !== newSku.innerHTML) {
      currentSku.replaceWith(newSku);
    }
  };
}

if (!customElements.get('product-sku')) {
  customElements.define('product-sku', ProductSku);
}

